import {Injectable} from '@angular/core';
import {ToastController} from '@ionic/angular';
import {ToastrService} from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class ToastService {

  constructor(private toastr: ToastrService) {

  }

  async SuccessToastShort(message: string) {
    this.toastr.success(message, '', {timeOut: 1500, positionClass: 'toast-bottom-right'});

  }

  async SuccessToast(message: string) {
    this.toastr.success(message, '', {timeOut: 2500, positionClass: 'toast-bottom-right'});

  }

  async SuccessToastLong(message: string) {
    this.toastr.success(message, '', {timeOut: 5000, positionClass: 'toast-bottom-right'});
  }

  async ErrorToastLong(title: string, message: string) {
    this.toastr.error(message, title, {timeOut: 7000, positionClass: 'toast-bottom-right'});

  }

  async ErrorToast(message: string) {
    this.toastr.error(message, '', {timeOut: 2500, positionClass: 'toast-bottom-right'});

  }

  async warningToast(massage: string) {
    this.toastr.warning(massage, '', {
      timeOut: 2500, positionClass: 'toast-bottom-right',
    });

  }

}
